export default __webpack_public_path__ + "static/media/code_first_girls.e4383c30.png";